import React from 'react'
import './Search.css'
import SingleAssetItem from '../Market/SingleAssetItem'
import DiscoverHeader from '../discover/DiscoverHeader'

const Search = () => {
    return (
        <div className="searchPage Marketui">
            <span className="searchPageHeader">Showing results for "art"</span>
            <DiscoverHeader />
            <ul className="pageItems assetItems">
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
                <SingleAssetItem
                    title ="Eggs Deneath our Legs A"
                    assetItemPath = "/user/username/asset"
                    assetThumb = "https://ipfs.pixura.io/ipfs/QmTiiw2DBG4H2CPUkcNKhWVMU7TNc3qLTLsbczKJmXjwzJ/eggs-beneath-our-legs-a.png"
                    assetAlt = "Eggs Deneath our Legs A"
                    price = {0.06}
                    priceCoin = "ETH"
                    likeCounter = {499}
                    buttonName = "Place a bid"
                    ownerUsername = "@fabianospeziari"
                    ownerUsernamePath = "user/username"
                    artistUsername = "@fabianospeziari"
                    artistUsernamePath = "user/username"
                />
            </ul>
        </div>
    )
}

export default Search
